import { useFlags } from 'launchdarkly-react-client-sdk';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import useUserPermissions from '@/hooks/useUserPermissions';

const Homepage = () => {
  const { replace } = useRouter();
  const { enableNonAdminActionCenterAccess } = useFlags();
  const { isAdmin } = useUserPermissions();

  useEffect(() => {
    if (!isAdmin && !enableNonAdminActionCenterAccess) {
      replace('/jobs');
    } else {
      replace('/action_center');
    }
  }, [enableNonAdminActionCenterAccess, isAdmin, replace]);

  return null;
};

export default Homepage;
